import React from 'react';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import Button from '@/components/Button';
import { Popover } from '@/components';

interface OnboardingPopoverProps {
  popoverOpen: boolean;
  setPopoverOpen: (arg0: boolean) => void;
}

export const OnboardingPopover: React.FC<OnboardingPopoverProps> = ({
  popoverOpen,
  setPopoverOpen,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <Popover open={popoverOpen} onClose={() => setPopoverOpen(false)}>
      {children}
      <Box sx={{ marginTop: 16, width: '100%', justifyItems: 'center' }}>
        <Button
          onClick={() => setPopoverOpen(false)}
          variant="contained"
          color="primary"
        >
          {t('app.close')}
        </Button>
      </Box>
    </Popover>
  );
};
